import { CaregiverScreen } from './screens/CaregiverScreen';
import { CategoriesScreen } from './screens/CategoriesScreen';
import { HelpScreen } from './screens/HelpScreen';
import { HomeScreen } from './screens/HomeScreen';
import { ManagerScreen } from './screens/ManagerScreen';
import { OnboardingScreen } from './screens/OnboardingScreen';
import { ProgressScreen } from './screens/ProgressScreen';
import { QuizScreen } from './screens/QuizScreen';
import { SettingsScreen } from './screens/SettingsScreen';
import { SignsLearnScreen } from './screens/SignsLearnScreen';
import { SignsScreen } from './screens/SignsScreen';
import { useT } from './hooks/useT';
import { useRouter } from './state/RouterContext';
import { useSettings } from './state/SettingsContext';

function CurrentScreen() {
  const { route } = useRouter();

  switch (route.name) {
    case 'home':
      return <HomeScreen />;
    case 'quiz':
      return <QuizScreen key={`${route.mode}-${route.categoryId ?? ''}`} mode={route.mode} categoryId={route.categoryId} />;
    case 'signs':
      return <SignsScreen />;
    case 'signsLearn':
      return <SignsLearnScreen />;
    case 'categories':
      return <CategoriesScreen />;
    case 'progress':
      return <ProgressScreen />;
    case 'caregiver':
      return <CaregiverScreen />;
    case 'settings':
      return <SettingsScreen />;
    case 'manager':
      return <ManagerScreen />;
    case 'help':
      return <HelpScreen />;
    default:
      return <HomeScreen />;
  }
}

export default function App() {
  const t = useT();
  const { settings } = useSettings();

  if (!settings.onboardingComplete) {
    return (
      <div className="app-shell">
        <OnboardingScreen />
      </div>
    );
  }

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">
        {t('skipToContent')}
      </a>
      <CurrentScreen />
    </div>
  );
}
